import enumDescription from "../../services/enumDescription";

// Processo do cliente (#480058): tipos do JSON de GET /processo/get/{id}
// (ProcessoConsultaService::detalhe) e as listas de situacao.

export enum SituacaoProcesso {
    ABERTO = 1,
    EXECUTANDO = 2,
    CONGELADO = 3,
    CANCELADO = 4,
    ARQUIVADO = 5,
    FINALIZADO = 6,
}

export enum SituacaoItem {
    PENDENTE = 1,
    EM_ANDAMENTO = 2,
    AGUARDANDO_CLIENTE = 3,
    CONCLUIDO = 4,
    DECLINADO = 5,
}

export enum TipoItem {
    CHECK = 1,
    SELECAO = 2,
    SELECAO_MULTIPLA = 3,
    TEXTO = 4,
    ARQUIVO = 5,
    DATA = 6,
}

export enum RegraObservacao {
    NAO = 0,
    OPCIONAL = 1,
    OBRIGATORIA = 2,
    CONFORME_OPCAO = 3,
}

export const TIPO_PAPEL_CLIENTE = 2;

export const SituacaoProcessoList = new enumDescription([
    {value: SituacaoProcesso.ABERTO, description: 'Aberto'},
    {value: SituacaoProcesso.EXECUTANDO, description: 'Executando'},
    {value: SituacaoProcesso.CONGELADO, description: 'Congelado'},
    {value: SituacaoProcesso.CANCELADO, description: 'Cancelado'},
    {value: SituacaoProcesso.ARQUIVADO, description: 'Arquivado com pendências'},
    {value: SituacaoProcesso.FINALIZADO, description: 'Finalizado'},
]);

/** Verbo do botao que leva a cada situacao. */
export const ACAO_SITUACAO: {[situacao: number]: string} = {
    [SituacaoProcesso.EXECUTANDO]: 'Retomar / reabrir',
    [SituacaoProcesso.CONGELADO]: 'Congelar',
    [SituacaoProcesso.CANCELADO]: 'Cancelar',
    [SituacaoProcesso.ARQUIVADO]: 'Arquivar com pendências',
    [SituacaoProcesso.FINALIZADO]: 'Finalizar',
};

export const COR_SITUACAO: {[situacao: number]: string} = {
    [SituacaoProcesso.ABERTO]: 'info',
    [SituacaoProcesso.EXECUTANDO]: 'primary',
    [SituacaoProcesso.CONGELADO]: 'warning',
    [SituacaoProcesso.CANCELADO]: 'secondary',
    [SituacaoProcesso.ARQUIVADO]: 'dark',
    [SituacaoProcesso.FINALIZADO]: 'success',
};

export const SituacaoItemList = new enumDescription([
    {value: SituacaoItem.PENDENTE, description: 'Pendente'},
    {value: SituacaoItem.EM_ANDAMENTO, description: 'Em andamento'},
    {value: SituacaoItem.AGUARDANDO_CLIENTE, description: 'Aguardando cliente'},
    {value: SituacaoItem.CONCLUIDO, description: 'Concluído'},
    {value: SituacaoItem.DECLINADO, description: 'Declinado'},
]);

export const SITUACAO_ETAPA: {[chave: string]: {rotulo: string, classe: string}} = {
    concluida: {rotulo: 'Concluída', classe: 'concluida'},
    aguardando_cliente: {rotulo: 'Aguardando cliente', classe: 'cliente'},
    atrasada: {rotulo: 'Atrasada', classe: 'atrasada'},
    andamento: {rotulo: 'Em andamento', classe: 'andamento'},
    nao_iniciada: {rotulo: 'Não iniciada', classe: 'nao-iniciada'},
};

export const CATEGORIAS_ANEXO = new enumDescription([
    {value: 1, description: 'Contrato'},
    {value: 2, description: 'Cronograma'},
    {value: 3, description: 'Manual'},
    {value: 4, description: 'Treinamento'},
    {value: 5, description: 'Ata'},
    {value: 6, description: 'Gravação'},
    {value: 7, description: 'Arquivo'},
]);

export const TIPOS_HISTORICO: {[tipo: string]: string} = {
    ABERTURA: 'Abertura',
    SITUACAO: 'Situação',
    RESPOSTA: 'Resposta',
    AGUARDANDO_CLIENTE: 'Pedido ao cliente',
    DECLINIO: 'Declínio',
    REABERTURA_ITEM: 'Reabertura',
    TRANSFERENCIA: 'Transferência',
    REPROGRAMACAO: 'Reprogramação',
    ANEXO: 'Anexo',
    COMENTARIO: 'Comentário',
    EVENTO: 'Agenda',
    ITEM_AVULSO: 'Item avulso',
    ALTERACAO: 'Alteração do processo',
    ATUALIZACAO_FLUXO: 'Atualização do fluxo',
};

export interface Opcao {
    valor: string,
    rotulo: string,
    exige_observacao: boolean,
}

export interface ItemProcesso {
    id: number,
    papel_id: number,
    grupo_codigo: string | null,
    grupo_nome: string | null,
    modulo_codigo: string | null,
    modulo_nome: string | null,
    titulo: string,
    orientacao: string | null,
    tipo: TipoItem,
    opcoes: Opcao[],
    observacao_regra: RegraObservacao,
    exige_anexo: boolean,
    permite_declinar: boolean,
    visivel_cliente: boolean,
    acao_cliente: string | null,
    avulso: boolean,
    situacao: SituacaoItem,
    resposta: any,
    observacao: string | null,
    justificativa_declinio: string | null,
    prazo_original: string,
    prazo: string,
    respondido_em: string | null,
    respondido_por: string | null,
    respondido_pelo_cliente: boolean,
    atrasado: boolean,
    vencendo: boolean,
    do_cliente: boolean,
    /** O cliente respondeu ou enviou arquivo pelo portal; a equipe revisa e conclui. */
    em_revisao: boolean,
    /** Duvidas que o cliente mandou pelo portal e a equipe ainda nao respondeu. */
    duvidas: DuvidaCliente[],
    anexos: number,
    pode_executar: boolean,
    /** Quem precisa agir: a pessoa do papel ou, no item do cliente, quem acompanha (null: papel sem pessoa). */
    quem_age: number | null,
}

export interface DuvidaCliente {
    id: number,
    quando: string,
    autor: string,
    mensagem: string,
}

export interface EtapaProcesso {
    id: number,
    nome: string,
    descricao: string | null,
    ordem: number,
    regra_inicio: number,
    duracao_dias_uteis: number,
    visivel_cliente: boolean,
    papel_id: number,
    previsao_inicio_original: string,
    previsao_fim_original: string,
    previsao_inicio: string,
    previsao_fim: string,
    data_inicio: string | null,
    data_fim: string | null,
    desvio_dias_uteis: number,
    percentual: number,
    situacao: string,
    itens_total: number,
    itens_resolvidos: number,
    itens_atrasados: number,
    itens: ItemProcesso[],
}

export interface PapelProcesso {
    id: number,
    codigo: string,
    nome: string,
    tipo: number,
    usuario: {id: number, nome: string} | null,
    contato: {nome: string | null, email: string | null, telefone: string | null, cargo: string | null} | null,
    pessoa: string | null,
    itens: number,
    resolvidos: number,
    atrasados: number,
    percentual: number,
}

export interface Processo {
    id: number,
    titulo: string,
    situacao: SituacaoProcesso,
    situacao_nome: string,
    transicoes: SituacaoProcesso[],
    complexidade: number | null,
    cliente: {id: number, nome: string},
    /** versao: a copiada pelo processo; versao_atual: a do fluxo hoje (#485540). */
    fluxo: {id: number, codigo: string, nome: string, versao: number, versao_atual: number},
    /** Ativo e com o fluxo em versao mais nova: o gestor pode atualizar (#485540). */
    fluxo_desatualizado: boolean,
    gestor: {id: number, nome: string},
    /** Webhook do Mattermost escolhido na abertura (null = o processo nao avisa no Mattermost). */
    webhook_mattermost: {id: number, nome: string} | null,
    modulos: string[],
    data_inicio: string,
    previsao_fim_original: string,
    previsao_fim: string,
    data_fim: string | null,
    desvio_dias_uteis: number,
    congelado_em: string | null,
    motivo_situacao: string | null,
    percentual: number,
    data_abertura: string,
    pode_gerir: boolean,
    /** A data de inicio so muda antes de qualquer execucao (#484909). */
    inicio_alteravel: boolean,
    etapa_atual_id: number | null,
    totais: {itens: number, resolvidos: number, atrasados: number, vencendo: number, pendencias_cliente: number, pendencias_equipe: number, em_revisao: number, duvidas: number},
    papeis: PapelProcesso[],
    etapas: EtapaProcesso[],
    /** Agenda do processo, em ordem de inicio (#484909). */
    eventos: Evento[],
    /** Contatos do cliente (#484909): para escolher como participante nos agendamentos. */
    contatos_cliente: ContatoCliente[],
}

/** Contato do cliente na implantacao (#484909). */
export interface ContatoCliente {
    id: number,
    nome: string,
    email: string | null,
    telefone: string | null,
    cargo: string | null,
    origem?: string,
    /** So na aba Responsaveis pelo cliente: o que o contato faz neste processo. */
    papeis?: string[],
    eventos?: number,
    proximo_evento?: {titulo: string, inicio: string} | null,
}

export interface Historico {
    id: number,
    tipo: string,
    data_hora: string,
    usuario: string | null,
    descricao: string,
    dados: any,
    etapa_id: number | null,
    item_id: number | null,
    visivel_cliente: boolean,
}

export interface Anexo {
    id: number,
    nome: string,
    categoria: number,
    tamanho: number,
    data: string,
    usuario: string | null,
    etapa_id: number | null,
    item_id: number | null,
    evento_id: number | null,
    visivel_cliente: boolean,
    enviado_pelo_cliente: boolean,
}

export const resolvido = (item: ItemProcesso) => item.situacao === SituacaoItem.CONCLUIDO || item.situacao === SituacaoItem.DECLINADO;

export const dataBr = (data: string | null | undefined) => {
    if (!data) {
        return '';
    }
    const [dia, hora] = data.split(' ');
    const [ano, mes, d] = dia.split('-');
    return `${d}/${mes}/${ano}${hora ? ` ${hora}` : ''}`;
};

export const dataCurta = (data: string | null | undefined) => (data ? dataBr(data).slice(0, 5) : '');

export const tamanhoArquivo = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const textoDesvio = (dias: number) => {
    if (dias > 0) return `+${dias} d.u.`;
    if (dias < 0) return `${dias} d.u.`;
    return 'no prazo';
};

/** Uma mudanca da atualizacao de versao do fluxo (#485540). */
export interface LinhaVersaoFluxo {
    escopo: 'item' | 'etapa' | 'papel',
    acao: 'incluido' | 'alterado' | 'removido',
    etapa: string | null,
    nome: string,
    campos: Array<{campo: string, de: string | null, para: string | null}>,
    motivo: string | null,
}

/** GET /processo/versao-fluxo/{id}: o que a atualizacao faz, sem gravar. */
export interface PreviaVersaoFluxo {
    versao_processo: number,
    versao_fluxo: number,
    em_dia: boolean,
    /** Processo sem execucao: o cronograma e refeito com a meta original. */
    refaz_meta: boolean,
    aplicar: LinhaVersaoFluxo[],
    confirmar: LinhaVersaoFluxo[],
    mantidos: LinhaVersaoFluxo[],
    papeis_sem_pessoa: Array<{codigo: string, nome: string}>,
    /** Etapas cuja previsao muda: "AAAA-MM-DD/AAAA-MM-DD" (de null = etapa nova). */
    cronograma: Array<{etapa: string, de: string | null, para: string}>,
    fim_atual: string,
    fim_novo: string,
}

/** Mensagem de erro da API (o ExceptionListener manda "error"). */
export const erroDaApi = (erro: any, padrao: string) => String(erro?.response?.data?.error ?? padrao);

export interface Evento {
    id: number,
    tipo: number,
    tipo_nome: string,
    titulo: string,
    inicio: string,
    fim: string | null,
    local: string | null,
    participantes: Array<{usuario_id: number | null, nome: string, email: string | null}>,
    situacao: number,
    situacao_nome: string,
    visivel_cliente: boolean,
    etapa_id: number | null,
    /** Item da checklist que o evento atende (#484909). */
    item_id: number | null,
    item_titulo: string | null,
    criado_por: string | null,
    /** O cliente agendou pelo portal. */
    pelo_cliente?: boolean,
    processo_id?: number,
    cliente?: string,
}

export const TIPOS_EVENTO = new enumDescription([
    {value: 1, description: 'Kick-off'},
    {value: 2, description: 'Reunião'},
    {value: 3, description: 'Treinamento'},
    {value: 4, description: 'Entrega'},
    {value: 5, description: 'Go-Live'},
    {value: 9, description: 'Outro'},
]);

export enum SituacaoEvento {
    AGENDADO = 1,
    REALIZADO = 2,
    CANCELADO = 3,
}

export interface PrazoAgenda {
    item_id: number,
    processo_id: number,
    cliente: string,
    etapa: string,
    titulo: string,
    prazo: string,
    atrasado: boolean,
    do_cliente: boolean,
    responsavel: string,
    /** Inicio do proximo evento agendado para o item, se houver. */
    agendado: string | null,
}

export interface AgendaGeral {
    inicio: string,
    fim: string,
    eventos: Evento[],
    prazos: PrazoAgenda[],
    vencidos: Array<{responsavel: string, total: number, itens: PrazoAgenda[]}>,
    vencendo: Array<{responsavel: string, total: number, itens: PrazoAgenda[]}>,
    carga: Array<{responsavel: string, total: number}>,
    janela_carga: number,
    marcos: Evento[],
    // So quem tem algo na tela; cada lista respeita os outros filtros.
    filtros: {
        gestores: OpcaoFiltro[],
        responsaveis: OpcaoFiltro[],
        clientes: OpcaoFiltro[],
    },
}

export interface OpcaoFiltro {
    id: number,
    nome: string,
}

/** "AAAA-MM-DD HH:MM" -> ISO local que o FullCalendar entende. */
export const isoLocal = (data: string) => data.replace(' ', 'T');

const DIAS_SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const doisDigitos = (n: number) => String(n).padStart(2, '0');

/** Date local -> "AAAA-MM-DD HH:MM" (o formato da API). */
export const dataHoraApi = (d: Date) =>
    `${d.getFullYear()}-${doisDigitos(d.getMonth() + 1)}-${doisDigitos(d.getDate())} ${doisDigitos(d.getHours())}:${doisDigitos(d.getMinutes())}`;

/** Hoje, local, "AAAA-MM-DD". */
export const hojeIso = () => dataHoraApi(new Date()).slice(0, 10);

/** "AAAA-MM-DD HH:MM" -> "qua, 15/10 10:00". */
export const quandoEvento = (inicio: string) => {
    const d = new Date(isoLocal(inicio.slice(0, 16)));
    return `${DIAS_SEMANA[d.getDay()]}, ${dataBr(inicio.slice(0, 10)).slice(0, 5)} ${inicio.slice(11, 16)}`;
};

/** Proximo evento agendado (de hoje em diante) da lista, que vem em ordem de inicio. */
export const proximoAgendado = (eventos: Evento[]) => {
    const hoje = hojeIso();
    return eventos.find(e => e.situacao === SituacaoEvento.AGENDADO && e.inicio.slice(0, 10) >= hoje) ?? null;
};

/** Eventos do item (#484909). */
export const eventosDoItem = (processo: Processo, itemId: number) => (processo.eventos || []).filter(e => e.item_id === itemId);

/** Eventos da etapa, os dos itens dela inclusive. */
export const eventosDaEtapa = (processo: Processo, etapaId: number) => (processo.eventos || []).filter(e => e.etapa_id === etapaId);

/** Tipo de evento que o item sugere pelo titulo: treinamento, kick-off, go-live, entrega; senao reuniao. */
export const tipoSugerido = (titulo: string) => {
    if (/treinamento/i.test(titulo)) return 3;
    if (/kick.?off/i.test(titulo)) return 1;
    if (/go.?live/i.test(titulo)) return 5;
    if (/entrega/i.test(titulo)) return 4;
    return 2;
};
